module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesNatural@2x.0c624d0.jpg";